import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock-1",
  "use": "icon-lock-1-usage",
  "viewBox": "0 0 8 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 10\" id=\"icon-lock-1\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 4V3C1 1.34315 2.34315 0 4 0C5.65685 0 7 1.34315 7 3V4C7.55228 4 8 4.44772 8 5V9C8 9.55228 7.55228 10 7 10H1C0.447715 10 0 9.55228 0 9V5C0 4.44772 0.447715 4 1 4ZM2 3C2 1.89543 2.89543 1 4 1C5.10457 1 6 1.89543 6 3V4H2V3Z\" fill=\"#3C1452\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol